/* eslint-disable react/no-danger */
/* eslint-disable jam3/no-sanitizer-with-danger */

import React, { ReactElement } from 'react';

import { sanitizeHTML } from '@/lib/util';

interface HeaderPropType {
  content: string;
}

const Header = ({ content }: HeaderPropType): ReactElement => (
  <div id="question-part">
    <div className="question-content-long">
      <div
        dangerouslySetInnerHTML={{
          __html: sanitizeHTML(content) as unknown as string,
        }}
      />
    </div>
  </div>
);

export default Header;
